<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.group_message'),
                        href: null,
                    },
                    {
                        name: message.batch,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <p v-html="message.message" class="whitespace-pre-line" />
        </div>

        <div v-if="message.image_path" class="mt-5">
            <img :src="message.image_path" class="mt-3" alt="" />
        </div>
        <AppCard v-if="message.attachments.length" class="mt-5">
            <AttachmentsList :attachments="message.attachments" />
        </AppCard>

        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div>
                <apexchart
                    :type="readCountChartData.chart.type"
                    height="350"
                    :series="readCountChartData.series"
                    :options="readCountChartData"
                >
                </apexchart>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppCard from '@/Shared/AppCard.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';

export default {
    components: {AttachmentsList, AppCard, PanelPage },
    layout: Layout,
    name: 'Show',
    props: ['message', 'readCountChartData'],
    data() {
        return {};
    },
};
</script>
